import { useTranslation } from 'react-i18next';
import { InfluencerReelPost, InfluencerNewProfileHeaderV2, SocialPostType } from '@anytag/graphql';
import { MediaPreviewWithMetrics } from '@anytag/shared-atoms';
import { THEME } from '@anytag/shared-constants';
import { usePostDetailsParam } from '@anytag/shared-hooks';
import { ImageSlider, InfluencerPostDetailsModal } from '@anytag/shared-molecules';
import { bigIntFormatter } from '@anytag/shared-utils';
import { useInfluencerProfileOpacityContent } from '../../../hooks';
import { InfluencerSelectedAccountInfo } from '../../../types';
import { InfluencerProfileFeedPostsWrapper } from '../../shared';

const REEL_PARAMS_KEY = 'reelPopup';

interface InfluencerInstagramProfileReelPostsProps {
  data?: readonly InfluencerReelPost[];
  socialAccount: InfluencerSelectedAccountInfo;
  influencerProfile: InfluencerNewProfileHeaderV2;
}

export const InfluencerInstagramProfileReelPosts = ({
  data = [],
  socialAccount,
  influencerProfile: { id: influencerId, name }
}: InfluencerInstagramProfileReelPostsProps) => {
  const { t } = useTranslation();
  const { setPostDetailsParam } = usePostDetailsParam(REEL_PARAMS_KEY);
  const { opacityContent } = useInfluencerProfileOpacityContent({
    influencerId,
    socialAccount,
    skipEstimateContent: true
  });

  return (
    <>
      <InfluencerProfileFeedPostsWrapper
        dataNotAvailable={!data.length}
        title={t('HeaderColumn.Reel Posts')}
        moreDetailProps={{
          to: '/influencer/$id/$socialMediaAccountId/scraping_feed_posts',
          params: { socialMediaAccountId: socialAccount.id.toString() },
          search: { filter: { name, type: SocialPostType.INSTAGRAM_REEL } }
        }}
        {...opacityContent}
      >
        <ImageSlider total={data.length} css={{ paddingLeft: '16px' }}>
          {data.map(({ id, thumbnail, likes, comments }) => (
            <MediaPreviewWithMetrics
              key={id}
              src={thumbnail}
              css={THEME.mediaPreview.igReelOrStory}
              onClick={() => setPostDetailsParam(id)}
              statistics={[
                { label: t('Like'), value: likes ? bigIntFormatter(likes, 0, { k: true, m: true }) : '-' },
                { label: t('General.Comments'), value: bigIntFormatter(comments, 0, { k: true, m: true }) }
              ]}
              isReel
              showIcon
            />
          ))}
        </ImageSlider>
      </InfluencerProfileFeedPostsWrapper>

      <InfluencerPostDetailsModal paramKey={REEL_PARAMS_KEY} posts={data.map(({ id }) => ({ id, influencerId }))} />
    </>
  );
};
